import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight, MessageSquare, Brain, Sparkles, Compass } from 'lucide-react';

const FONT_HEAD = { fontFamily: '"Cabinet Grotesk", "Manrope", sans-serif' };

export default function AIVisibilityTeaser() {
  return (
    <section data-testid="homepage-teaser-section" className="relative bg-slate-950 border-y border-slate-800 py-24 overflow-hidden">
      {/* Tracing beam border */}
      <motion.div
        aria-hidden
        className="pointer-events-none absolute inset-x-6 top-6 bottom-6 rounded-2xl"
        style={{ background: 'conic-gradient(from var(--beam-angle,0deg), transparent 0deg, transparent 300deg, #3b82f6 340deg, #60a5fa 360deg)', WebkitMask: 'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)', WebkitMaskComposite: 'xor', maskComposite: 'exclude', padding: '1px' }}
        animate={{ ['--beam-angle']: ['0deg', '360deg'] }}
        transition={{ duration: 6, repeat: Infinity, ease: 'linear' }}
      />
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <span className="inline-block text-xs font-bold uppercase tracking-[0.25em] text-blue-400 mb-6">New AI Capability</span>
        <h2 className="text-3xl md:text-5xl font-black tracking-tighter text-white leading-[1.1]" style={FONT_HEAD}>
          Are you the answer when customers ask AI?
        </h2>
        <p className="mt-6 text-base md:text-lg font-light text-slate-300 max-w-2xl mx-auto leading-relaxed">
          ChatGPT and Perplexity have replaced traditional search. If your business isn't recommended by AI, you are invisible to your next customer.
        </p>
        <div className="mt-8 flex items-center justify-center gap-6 text-blue-400">
          <MessageSquare className="h-6 w-6" /><Brain className="h-6 w-6" /><Sparkles className="h-6 w-6" /><Compass className="h-6 w-6" />
        </div>
        <Link to="/ai-visibility" data-testid="homepage-teaser-cta" className="inline-block mt-8">
          <Button className="h-12 px-8 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-bold text-base transition-colors">
            Test Your AI Visibility <ArrowRight className="h-5 w-5 ml-2" />
          </Button>
        </Link>
      </div>
    </section>
  );
}
